export const RADAR_FINANCEIRO = () => '/contac/radar';
